import React, { Fragment, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import DialogBoxComponent from "../../../components/DialogBoxComponent";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Stack, Typography } from "@mui/material";
import { getImportVulnerabilityList, importNewVulnerability } from "./helper";
import { useRiskAssessmentContext } from "../../../context/RiskAssessment/RiskAssessmentContext";
import { useUserContext } from "../../../context/auth/UserContext";

export const VulnerabilityImport = (props: {
  openDialog: boolean;
  handleCancel: () => void;
  refreshList: () => void;
  vulnerabilityList: any[];
}) => {
  const { userId, companyProfileID } = useUserContext();

  const { setVulnerabilityList, vulnerabilityList } =
    useRiskAssessmentContext();
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  const [importVulnerabilityList, setImportVulnerabilityList] = useState<any[]>(
    []
  );
  const [importVulnerabilityListOrg, setImportVulnerabilityListOrg] = useState<
    any[]
  >([]);
  const [existingVulnerability, setExsistingVulnerability] = useState<any[]>(
    []
  );
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openImportConfirmation: false,
    openSuccessDialogBox: false,
  });

  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectAll(false);
      setChecked([]);
    } else {
      setSelectAll(true);
      const newChecked = importVulnerabilityList.map(
        (ele) => ele.vulnerabilityId
      );
      setChecked(newChecked);
    }
  };

  const handleClose = () => {
    if (props.handleCancel) {
      props.handleCancel();
    }
    setChecked([]);
    setSelectAll(false);
    setExsistingVulnerability([]);
    setImportVulnerabilityList([]);
    setImportVulnerabilityListOrg([]);
    setOpen(false);
  };

  const handleCloseDialog = () => {
    if (dialogState.title !== "Error") {
      setDialogState({
        ...dialogState,
        openImportConfirmation: false,
        openSuccessDialogBox: false,
      });
      props.refreshList();
      handleClose();
    } else {
      setDialogState({
        ...dialogState,
        openImportConfirmation: false,
        openSuccessDialogBox: false,
      });
    }
  };

  const getSelectedvulnerability = () => {
    return importVulnerabilityList.filter((ele) =>
      checked.includes(ele.vulnerabilityId)
    );
  };

  const getExistingVulnerability = (selectedVulnerability: any[]) => {
    // console.log("getExistingVulnerability", props.vulnerabilityList);

    return selectedVulnerability
      .filter((vulnerability: any) => {
        return props.vulnerabilityList.some(
          (ele: any) =>
            ele.vulnerabiliteName === vulnerability.vulnerabiliteName
        );
      })
      .map((vulnerability: any) => {
        const matchedVulnerability: any = props.vulnerabilityList.find(
          (ele: any) =>
            ele.vulnerabiliteName === vulnerability.vulnerabiliteName
        );
        return {
          ...vulnerability,
          VulnerabilityID: matchedVulnerability.vulnerabilityId,
        };
      });
  };

  const handleImport = async () => {
    // const selectedVulnerability = getSelectedvulnerability();
    // const isExsistingVulnerability = await getExistingVulnerability(
    //   selectedVulnerability
    // );
    // setExsistingVulnerability(isExsistingVulnerability);
    // console.log("isExsistingVulnerability", isExsistingVulnerability);
    // if (isExsistingVulnerability.length > 0) {
    //   const existingVulnerabilityNames = isExsistingVulnerability
    //     .map((vulnerability) => vulnerability.vulnerabiliteName)
    //     .join(", ");
    //   setDialogState({
    //     title: "Confirm",
    //     body: `The following vulnerability are already existing in the list: <strong>${existingVulnerabilityNames}</strong>. If you import, they will be overwritten. Are you sure?`,
    //     action: "Import",
    //     actionCancel: "Cancel",
    //     openImportConfirmation: true,
    //     openSuccessDialogBox: false,
    //   });
    // } else {
    importVulnerability();
    // }
  };

  const importVulnerability = async () => {
    setIsLoading(true);
    const selectedVulnerability = getSelectedvulnerability();
    // const newlyImportVulnerability = selectedVulnerability.filter(
    //   (vulnerability) =>
    //     !existingVulnerability.some(
    //       (existingVulnerability) =>
    //         existingVulnerability.vulnerabiliteName ===
    //         vulnerability.vulnerabiliteName
    //     )
    // );

    let hasError = false;
    const date = new Date();

    //Import new Vulnerability

    const payload = selectedVulnerability.map((ele) => {
      return {
        vulnerabiliteName: ele.vulnerabiliteName,
        createDate: date,
        createdBy: userId,
        companyProfileID: companyProfileID,
        templateId: ele.vulnerabilityId,
      };
    });
    //   console.log("payload newlyImportVulnerability", payload);
    const resImport = await importNewVulnerability(payload);
    if (!resImport.succeeded) {
      hasError = true;
    }

    if (hasError) {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openImportConfirmation: false,
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Success",
        body: "Vulnerability successfully imported",
        action: "OK",
        actionCancel: "",
        openImportConfirmation: false,
        openSuccessDialogBox: true,
      });
    }
    setIsLoading(false);
  };

  const fetchVulnerabilityImport = async () => {
    try {
      const res = await getImportVulnerabilityList();
      const filteredRes = res.filter((resItem: any) => {
        return !vulnerabilityList.some(
          (existingItem: any) =>
            existingItem.vulnerabiliteName === resItem.vulnerabiliteName
        );
      });
      setImportVulnerabilityList(filteredRes);
      setImportVulnerabilityListOrg(res);
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setOpen(props.openDialog);
    setIsLoading(true);
    if (props.openDialog) {
      fetchVulnerabilityImport();
    }
  }, [props.openDialog]);

  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose} keepMounted>
        <DialogTitle sx={{ fontSize: "1.1rem" }}>
          Import Vulnerability
        </DialogTitle>
        <DialogContent>
          {importVulnerabilityList.length > 0 ? (
            <Stack direction="row" sx={{ mx: 2 }}>
              <Checkbox
                size="small"
                edge="start"
                checked={selectAll}
                onChange={handleSelectAll}
                tabIndex={-1}
                disableRipple
                sx={{ p: 0, mr: 3 }}
              />
              <span>Select All</span>
            </Stack>
          ) : null}

          <DialogContentText sx={{ height: "300px", overflowY: "scroll" }}>
            <List sx={{ width: "300px", bgcolor: "background.paper" }}>
              {!isLoading ? (
                importVulnerabilityListOrg.length > 0 ? (
                  importVulnerabilityList.length > 0 ? (
                    importVulnerabilityList
                      .sort((a, b) => {
                        const nameA = a.vulnerabiliteName || "";
                        const nameB = b.vulnerabiliteName || "";
                        return nameA.localeCompare(nameB);
                      })
                      .map((ele) => {
                        const labelId = `checkbox-list-label-${ele}`;
                        return (
                          <ListItem
                            key={ele.vulnerabilityId}
                            disablePadding
                            disableGutters
                          >
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(ele.vulnerabilityId)}
                              dense
                            >
                              <ListItemIcon sx={{ minWidth: "2rem" }}>
                                <Checkbox
                                  size="small"
                                  edge="start"
                                  checked={
                                    checked.indexOf(ele.vulnerabilityId) !== -1
                                  }
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                  sx={{ p: 0 }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                primary={ele.vulnerabiliteName}
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })
                  ) : (
                    <Typography textAlign="center">
                      All the vulnerabilities are already imported.
                    </Typography>
                  )
                ) : (
                  <Typography textAlign="center">
                    No vulnerabilities to import
                  </Typography>
                )
              ) : (
                <Box display="flex" justifyContent="center" alignItems="center">
                  <CircularProgress />
                </Box>
              )}
            </List>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "0.5rem 1.5rem" }}>
          <Button
            size="small"
            variant="contained"
            className="table-btn"
            disabled={isLoading}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={checked.length === 0 || isLoading}
            className="table-btn"
            onClick={checked.length === 0 || handleImport}
          >
            Import
          </Button>
        </DialogActions>
      </Dialog>
      {
        //Confirmation
        <DialogBoxComponent
          openDialogBox={dialogState.openImportConfirmation}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={importVulnerability}
          handleCancel={handleCloseDialog}
        />
      }
      {
        //success
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
